import React, { JSX } from 'react'
import { Navigate, useLocation, useParams } from 'react-router'
import { QuickOverlayManagerView } from 'components/chatOverlays/ChatOverlayManager'
import { TickerBarManager } from 'components/chatOverlays/TickerBarManager'
import { LoadingSpinner } from 'components/Loading'
import { useEventDetail } from 'hooks/useEventDetail'
import { tickerBarPageGuard, useTickerBarSurfaceVisible } from 'hooks/useTickerBarSurfaceVisible'
import { eventSectionPath } from 'lib/paths'

export const TickerBarsPage = (): JSX.Element => {
  const { eventId = '', tickerBarId } = useParams<{ eventId: string, tickerBarId: string }>()
  const { pathname } = useLocation()
  const { event, refetchEvent, setEvent } = useEventDetail()
  const guard = tickerBarPageGuard(useTickerBarSurfaceVisible())
  if (guard === 'redirect') return <Navigate to={eventSectionPath(eventId, 'overview')} replace />
  if (guard === 'wait') {
    return (
      <div className='flex flex-1 items-center justify-center py-10' data-testid='ticker-page-pending'>
        <LoadingSpinner />
      </div>
    )
  }
  const basePath = eventSectionPath(eventId, 'message-tickers')
  let view: QuickOverlayManagerView = 'list'
  if (pathname.endsWith('/new')) view = 'create'
  else if (tickerBarId != null) view = { edit: tickerBarId }
  return (
    <TickerBarManager
      view={view}
      basePath={basePath}
      backLabel='Back to Message tickers'
      scope={{ kind: 'stream', event, refetchEvent, setEvent }}
    />
  )
}
